import React from "react";
import ReactDOM from "react-dom";
import App from "./app.js";
ReactDOM.render(
  <React.Fragment>
    <App />
  </React.Fragment>,
  document.getElementById("root")
);
